module.exports = __webpack_public_path__ + "static/media/transbank.9f373014.svg";